import { render, staticRenderFns } from "./addRoles.vue?vue&type=template&id=332fba1a"
import script from "./addRoles.vue?vue&type=script&lang=js"
export * from "./addRoles.vue?vue&type=script&lang=js"
import style0 from "./addRoles.vue?vue&type=style&index=0&id=332fba1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports